import { CreateSpecialtyGroupException } from "@app/exceptions/interfaces";
import { NetworkSubmissionProject, NetworkSubmissionWizardStep } from "@app/compliance-connect/network-submission/interfaces";

export enum NetworkSubmissionWizardAction {
  AddPendingException = "ADD_PENDING_EXCEPTION",
  SelectProject = "SELECT_PROJECT",
  SetComments = "SET_COMMENTS",
  SetEmailSharedUsers = "SET_EMAIL_SHARED_USERS",
  SetIsConfirmed = "SET_IS_CONFIRMED",
  SetPage = "SET_PAGE",
  SetRegulatorClientId = "SET_REGULATOR_CLIENT_ID",
  SetSharedUserIds = "SET_SHARED_USER_IDS",
  SetSubmissionDescription = "SET_SUBMISSION_DESCRIPTION",
  SetSubmissionName = "SET_SUBMISSION_NAME",
}

export type NetworkSubmissionWizardActions =
  | { type: NetworkSubmissionWizardAction.AddPendingException; payload: { exception: CreateSpecialtyGroupException; key: string } }
  | { type: NetworkSubmissionWizardAction.SelectProject; payload: NetworkSubmissionProject | null }
  | { type: NetworkSubmissionWizardAction.SetComments; payload: string }
  | { type: NetworkSubmissionWizardAction.SetEmailSharedUsers; payload: boolean }
  | { type: NetworkSubmissionWizardAction.SetIsConfirmed; payload: boolean }
  | { type: NetworkSubmissionWizardAction.SetPage; payload: NetworkSubmissionWizardStep }
  | { type: NetworkSubmissionWizardAction.SetRegulatorClientId; payload: number | null }
  | { type: NetworkSubmissionWizardAction.SetSharedUserIds; payload: number[] }
  | { type: NetworkSubmissionWizardAction.SetSubmissionDescription; payload: string }
  | { type: NetworkSubmissionWizardAction.SetSubmissionName; payload: string };
